import React, { useEffect, useState } from 'react';
import { CalendarDays, Loader2 } from 'lucide-react';
import { DashboardLayout, companyMenuItems } from '../../components/DashboardLayout';
import { interviewsAPI } from '../../lib/api';
import { InterviewCard } from '../../components/interviews/InterviewCard';
import { ACTIVE_STATUS, fmtDay } from '../../components/interviews/interviewUtils';

const FILTERS = [
  { key: 'proximas', label: 'Em aberto', test: (i) => ACTIVE_STATUS.includes(i.status) },
  { key: 'realizadas', label: 'Realizadas', test: (i) => i.status === 'REALIZADA' },
  { key: 'canceladas', label: 'Canceladas', test: (i) => i.status === 'CANCELADA' },
  { key: 'todas', label: 'Todas', test: () => true },
];

const groupByDay = (items) => items.reduce((acc, i) => {
  const d = new Date(i.data_hora).toDateString();
  (acc[d] = acc[d] || []).push(i);
  return acc;
}, {});

export default function InterviewAgenda() {
  const [items, setItems] = useState(null);
  const [filter, setFilter] = useState('proximas');
  const load = () => interviewsAPI.list().then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const f = FILTERS.find((x) => x.key === filter);
  const list = (items || []).filter(f.test);
  const sorted = filter === 'proximas' ? list : [...list].reverse();
  const groups = groupByDay(sorted);
  const pendentes = (items || []).filter((i) => i.status === 'NOVO_HORARIO').length;

  return (
    <DashboardLayout menuItems={companyMenuItems}>
      <div className="space-y-6" data-testid="interview-agenda-page">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><CalendarDays className="w-6 h-6 text-cyan-600" />Agenda de Entrevistas</h1>
          <p className="text-sm text-slate-500 mt-1">Todas as entrevistas da empresa, organizadas por dia.</p>
        </div>
        {pendentes > 0 && (
          <div className="rounded-lg border border-orange-200 bg-orange-50 p-3 text-sm text-orange-900" data-testid="agenda-pending-suggestions">
            {pendentes} candidato(s) pediram outro horário. Aceite ou remarque.
          </div>
        )}
        <div className="flex flex-wrap gap-2">
          {FILTERS.map((x) => (
            <button key={x.key} onClick={() => setFilter(x.key)} data-testid={`agenda-filter-${x.key}`}
              className={`rounded-full px-4 py-1.5 text-sm border transition-colors ${filter === x.key ? 'bg-cyan-600 text-white border-cyan-600' : 'bg-white hover:bg-slate-50'}`}>
              {x.label} ({(items || []).filter(x.test).length})
            </button>
          ))}
        </div>
        {!items ? <Loader2 className="w-6 h-6 animate-spin text-cyan-600" /> : !sorted.length ? (
          <p className="text-slate-500 text-sm py-10 text-center" data-testid="agenda-empty">Nenhuma entrevista aqui. Agende pelo botão "Agendar entrevista" de um candidato que aceitou o convite.</p>
        ) : Object.entries(groups).map(([day, ivs]) => (
          <section key={day} className="space-y-2" data-testid="agenda-day-group">
            <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">{fmtDay(ivs[0].data_hora)}</h2>
            {ivs.map((iv) => <InterviewCard key={iv.id} interview={iv} onChange={load} />)}
          </section>
        ))}
      </div>
    </DashboardLayout>
  );
}
